module.exports = __webpack_public_path__ + "img/logo.79d8527c.svg";